// extracted by mini-css-extract-plugin
module.exports = {"brand":"Brand_brand__J4GLw","logo":"Brand_logo__i33dp","name":"Brand_name__mLuAF","text":"Brand_text__LLZ8g"};